import React, { useContext, useEffect, useState } from 'react';
import { OfferContext, VignetteContext, getCartEntriesSortedByModuleType } from '@adac-mp/shared';
import { SortedProductsSection } from '@adac-mp/components';

interface IProductSummaryCheckoutProps {
	hasCategories: boolean;
	hasFuelType: boolean;
	hasSpecialPlates?: boolean;
	memberNo?: string;
}

export const ProductSummaryCheckout = ({
	hasCategories,
	hasFuelType,
	hasSpecialPlates = false,
	memberNo,
}: IProductSummaryCheckoutProps) => {
	const { allOffers } = useContext(OfferContext);
	const { cartItems } = useContext(VignetteContext);
	const sortedCartItems = getCartEntriesSortedByModuleType(cartItems, allOffers);
	const [openProductKey, setOpenProductKey] = useState<string | undefined>(undefined);

	const handleToggle = (currentKey?: string) =>
		setOpenProductKey(openProductKey !== currentKey ? currentKey : undefined);

	useEffect(() => {
		if (cartItems.length === 1) {
			setOpenProductKey(`${cartItems[0].offer.serviceCatalogId}-0`);
		}
	}, [cartItems]);

	return (
		<div className="flex flex-col mb-5">
			{sortedCartItems.map(([moduleType, orderedCartItems], sectionIndex) => (
				<SortedProductsSection
					key={sectionIndex}
					hasCategories={hasCategories}
					hasFuelType={hasFuelType}
					hasSpecialPlates={hasSpecialPlates}
					memberNo={memberNo}
					moduleType={moduleType}
					openProductKey={openProductKey}
					orderedCartItems={orderedCartItems}
					sectionIndex={sectionIndex}
					handleToggle={handleToggle}
				/>
			))}
		</div>
	);
};
